import { useQuery } from '@tanstack/react-query';

import { packagingApi } from 'api/packaging';

export const packagingPurchaseOrderQueryKeys = {
    all: ['packagingPurchaseOrders'],
    search: (filters) => ['packagingPurchaseOrders', 'v2', 'search', filters],
};

/**
 * Hook for fetching packaging purchase orders.
 *
 * @param {Object} params - Query parameters.
 * @param {string} params.status - Packaging PO status filter.
 * @param {number|string} params.facilityID - Facility identifier.
 * @param {Object} options - React Query options.
 */
export const usePackagingPurchaseOrders = (params = {}, options = {}) => {
    const { facilityID, status = '' } = params;

    return useQuery({
        queryKey: packagingPurchaseOrderQueryKeys.search({ facilityID, status }),
        queryFn: async () => {
            // TODO: Create and use new API endpoint for filtered paginated packaging purchase orders
            const response = await packagingApi.getPurchaseOrders(status, facilityID);
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch packaging purchase orders');
            }
            return response?.data?.rows ?? [];
        },
        staleTime: 30 * 1000,
        ...options,
        enabled: Boolean(facilityID) && (options.enabled ?? true),
    });
};
